var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gj-input',_vm._g(_vm._b({style:({width: _vm.width}),attrs:{"isEnter":"","clearable":""},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [_vm._t("suffix")]},proxy:true}],null,true)},'gj-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }